import "core-js/modules/es.array.reverse.js";
var _class, _SocrataMapViewStratum;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable, runInAction } from "mobx";
import { toFeatureCollection } from "../../../Core/GeoJson";
import loadJson from "../../../Core/loadJson";
import TerriaError from "../../../Core/TerriaError";
import GeoJsonMixin from "../../../ModelMixins/GeojsonMixin";
import SocrataMapViewCatalogItemTraits from "../../../Traits/TraitsClasses/SocrataMapViewCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import LoadableStratum from "../../Definition/LoadableStratum";
import StratumOrder from "../../Definition/StratumOrder";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
/** This will fetch `views` for a given Socrata `resourceId`.
 * From the JSON response we get `childViews` - which can be used to generate a URL to fetch GeoJSON
 */
export let SocrataMapViewStratum = (_class = (_SocrataMapViewStratum = class SocrataMapViewStratum extends LoadableStratum(SocrataMapViewCatalogItemTraits) {
  static async load(catalogGroup) {
    if (!catalogGroup.url) throw "`url` must be set";
    if (!catalogGroup.resourceId) throw "`resourceId` must be set";
    const viewResponse = await loadJson(proxyCatalogItemUrl(catalogGroup, "".concat(catalogGroup.url, "/views/").concat(catalogGroup.resourceId)));
    if (viewResponse.error) {
      var _viewResponse$message;
      throw (_viewResponse$message = viewResponse.message) !== null && _viewResponse$message !== void 0 ? _viewResponse$message : viewResponse.error;
    }
    return new SocrataMapViewStratum(catalogGroup, viewResponse);
  }
  get geojsonUrl() {
    var _this$view;
    if ((_this$view = this.view) !== null && _this$view !== void 0 && (_this$view = _this$view.childViews) !== null && _this$view !== void 0 && _this$view[0]) return "".concat(this.catalogItem.url, "/resource/").concat(this.view.childViews[0], ".geojson?$limit=10000");
  }
  duplicateLoadableStratum(model) {
    return new SocrataMapViewStratum(model, this.view);
  }
  constructor(catalogItem, view) {
    super();
    this.catalogItem = catalogItem;
    this.view = view;
    makeObservable(this);
  }
}, _defineProperty(_SocrataMapViewStratum, "stratumName", "socrataMapView"), _SocrataMapViewStratum), _applyDecoratedDescriptor(_class.prototype, "geojsonUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "geojsonUrl"), _class.prototype), _class);
StratumOrder.addLoadStratum(SocrataMapViewStratum.stratumName);

/**
 * Use the Socrata `views` API to fetch data.
 * This mimics how Socrata portal map visualisation works - it isn't an official API
 */
export default class SocrataMapViewCatalogItem extends GeoJsonMixin(CreateModel(SocrataMapViewCatalogItemTraits)) {
  get type() {
    return SocrataMapViewCatalogItem.type;
  }
  async forceLoadMetadata() {
    if (!this.strata.has(SocrataMapViewStratum.stratumName)) {
      const stratum = await SocrataMapViewStratum.load(this);
      runInAction(() => {
        this.strata.set(SocrataMapViewStratum.stratumName, stratum);
      });
    }
  }
  async forceLoadGeojsonData() {
    if (this.geojsonUrl) {
      const result = await loadJson(proxyCatalogItemUrl(this, this.geojsonUrl));
      const fc = toFeatureCollection(result);
      if (fc) return fc;else throw TerriaError.from("Failed to parse geoJSON");
    }
    throw TerriaError.from("Failed to fetch geoJSON - no URL was provided");
  }
}
_defineProperty(SocrataMapViewCatalogItem, "type", "socrata-map-item");